import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TicketForm from './TicketForm';
import Login from './Login';
import TokenHandler from './TokenHandler';

function App() {
  return (
    <>
      <TokenHandler />
      <Routes>
        <Route path="/" element={<TicketForm />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </>
  );
}

export default App;
